module.exports = __webpack_public_path__ + "img/logo-h.e7d3f82a.png";